export default __webpack_public_path__ + "static/7_32-9d18c6c00963e6da1e6c771651668ca9.png";